
class UserService {

    constructor(axios, baseUrl) {

        this.baseUrl = `${baseUrl}/user/`;
        this.axios = axios
    }

    login(email, password) {

        let self = this;
        return this.axios.post(`${self.baseUrl}loguin`, { "user": { "email": email, "password": password } })
    }

    forgotPassword(email) {

        let self = this;
        let data = Object.assign({},email, { urlFrom:window.location.origin})
        return this.axios.post(`${self.baseUrl}forgotPassword`, data )

    }
    changePassword(data) {

        let self = this;
        let passData = Object.assign({}, { password: data.password }, { passwordconfirmation: data.passwordconfirmation }, { token: data.token })
        return this.axios.post(`${self.baseUrl}tokenverification`, passData)

    }
    getAll(token) {
        this.user = { params: { token } };
        let self = this;
        return self.axios.get(self.baseUrl, self.user)
    }
    getOne(id, token) {
        let self = this;
        this.user = { params: { token } };
        return self.axios.get(`${self.baseUrl}/${id}`, self.user)
    }

    create(user, token) {

        let self = this;
        let data = Object.assign({}, user, { token })
        return this.axios.post(`${self.baseUrl}create`, data)

    }
    update(user, token) {

        let self = this;
        let data = Object.assign({}, user, { token })
        return this.axios.post(`${self.baseUrl}update`, data)

    }
    remove(id, token) {
        let self = this;
        let data = Object.assign({}, { id }, { token })
        return this.axios.post(`${self.baseUrl}remove`, data)
    }

}

export default UserService;


// WEBPACK FOOTER //
// ./src/services/userService.js